import { differenceLeft } from './array';

const isRestricted = (setup, attrs = {}) => {
	if (attrs.inActive) return true;
	if (setup?.languages && Object.keys(setup.languages).length > 0) {
		const defaultLanguage = setup.languages.default;
		const language = defaultLanguage?.language === setup.language ? 'default' : setup.language;
		// Restrict content based on language
		if (attrs.selectedLanguages && Array.isArray(attrs.selectedLanguages) && attrs.selectedLanguages.indexOf(language) === -1) return true;
		if (attrs.restrictedLanguages && Array.isArray(attrs.restrictedLanguages) && attrs.restrictedLanguages.indexOf(language) !== -1) return true;
	}


	const campaignType = setup.campaignType || 'standard';
	if (attrs.selectedCustomRestrictions && Array.isArray(attrs.selectedCustomRestrictions)) {
		// Restrict content based on filter settings
		if (attrs.selectedCustomRestrictions.indexOf(campaignType) === -1 && Array.isArray(setup?.filterRestriction) && setup.filterRestriction.length > 0) {
			if (attrs.selectedCustomRestrictions && Array.isArray(attrs.selectedCustomRestrictions) && differenceLeft(attrs.selectedCustomRestrictions, setup.filterRestriction).length > 0) return true;
			// Restrict content based on campaign type / standard
		} else if (attrs.selectedCustomRestrictions.indexOf(campaignType) === -1) return true;
	}
	if (attrs.restrictedCustomRestrictions && Array.isArray(attrs.restrictedCustomRestrictions)) {
		// Restrict content based on filter settings
		if (attrs.restrictedCustomRestrictions.indexOf(campaignType) !== -1 && Array.isArray(setup?.filterRestriction) && setup.filterRestriction.length > 0) {
			if (attrs.restrictedCustomRestrictions && Array.isArray(attrs.restrictedCustomRestrictions) && differenceLeft(attrs.restrictedCustomRestrictions, setup.filterRestriction).length === 0) return true;
			// Restrict content based on campaign type / standard
		} else if (attrs.restrictedCustomRestrictions.indexOf(campaignType) !== -1) return true;
	}


	// Restrict content based on country
	if (attrs.selectedCountries && Array.isArray(attrs.selectedCountries) && attrs.selectedCountries.indexOf(setup.country) === -1) return true;
	if (attrs.restrictedCountries && Array.isArray(attrs.restrictedCountries) && attrs.restrictedCountries.indexOf(setup.country) !== -1) return true;
	// Restrict based on "device" desktop >= 900 mobile < 600
	if (attrs.desktop && !(setup.breakPoint === 'desktop' || setup.breakPoint === 'tablet')) return true;
	if (attrs.mobile && setup.breakPoint !== 'mobile') return true;

	return false;
};

const restrictedType = (setup, attrs = {}) => {
	if (attrs.inActive) return 'inActive';
	if (setup?.languages && Object.keys(setup.languages).length > 0) {
		const defaultLanguage = setup.languages.default;
		const language = defaultLanguage?.language === setup.language ? 'default' : setup.language;
		// Restrict content based on language
		if (attrs.selectedLanguages && Array.isArray(attrs.selectedLanguages) && attrs.selectedLanguages.indexOf(language) !== -1) return 'language';
		if (attrs.restrictedLanguages && Array.isArray(attrs.restrictedLanguages) && attrs.restrictedLanguages.indexOf(language) === -1) return 'language';
	}
	// Restrict content based on country
	if (attrs.selectedCountries && Array.isArray(attrs.selectedCountries) && attrs.selectedCountries.indexOf(setup.country) !== -1) return 'country';
	if (attrs.restrictedCountries && Array.isArray(attrs.restrictedCountries) && attrs.restrictedCountries.indexOf(setup.country) === -1) return 'country';
	// Restrict based on "device" desktop >= 900 mobile < 600
	if (attrs.desktop && (setup.breakPoint === 'desktop' || setup.breakPoint === 'tablet')) return 'desktop';
	if (attrs.mobile && setup.breakPoint === 'mobile') return 'mobile';

	return '';
};

export { isRestricted, restrictedType };
